export default __webpack_public_path__ + "static/media/onboarding-intro.4f7bff5e.svg";